import { StoreState } from "../../models/states/StoreState";
import { VariableErrorModel } from "../VariableErrorModel";
import { VariableType } from "../../models/enums/VariableType";
import { makeMentionsSelector } from "../../redux/selectors/mentions";
import { isNullOrEmpty } from "../../utils";

const inputRequiredKey = "INPUT_REQUIRED";
const inputRequiredValueTrue = true;

const answerRequiredKey = "AnswerRequired";
const answerRequiredValueTrue = undefined;

const errorKey = "IncompleteAnswer";

export default function answerRequired(question) {
    const [variable] = question.variables.filter((v) => v.type !== VariableType.Computed);
    if (!variable) {
        return null;
    }
    const { name: variableName } = variable;

    const mentionsSelector = makeMentionsSelector(variableName);

    return (getState: () => StoreState): VariableErrorModel => {
        const {
            interview: { questionnaire },
        } = getState();

        const isInputRequired = questionnaire.settings[inputRequiredKey] === inputRequiredValueTrue;
        const isAnswerRequired = question.settings[answerRequiredKey] === answerRequiredValueTrue;

        if (isInputRequired && isAnswerRequired) {
            const mentions = mentionsSelector(getState());
            const isValid = mentions.length && !isNullOrEmpty(mentions[0].value);
            if (!isValid) {
                return { variableName, error: { key: errorKey } };
            }
        }

        return null;
    };
}
